"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const logo_module_scss_1 = __importDefault(require("./logo.module.scss"));
const Logo = (_a) => {
    var { className = "", type = "full", fullType = "red-dark-gray", iconType = "red", width = type === "full" ? "120px" : "20px", style } = _a, props = __rest(_a, ["className", "type", "fullType", "iconType", "width", "style"]);
    return (react_1.default.createElement("div", Object.assign({ className: `${logo_module_scss_1.default.logo} ${className}`, "data-type": type, style: Object.assign({ width: width }, style) }, props),
        react_1.default.createElement("span", { className: `${logo_module_scss_1.default.img}`, "data-type": type, "data-full-type": fullType, "data-icon-type": iconType },
            type === "full" && `Camp Gladiator`,
            type === "icon" && `CG`)));
};
exports.default = (0, react_1.memo)(Logo);
//# sourceMappingURL=logo.js.map